module.exports = __webpack_public_path__ + "img/img_empty.703250b8.png";